module.exports = __webpack_public_path__ + "assets/img/5.2f29aaa2.png";